import { useReduxState } from 'hooks';
import { ProgressBar } from 'components/common';
import { ProgressLabel } from '.';

interface Props {
  analyticsDisabledForAdmin?: boolean;
  discrepancyInCompletion?: boolean;
  numberOfVideos: number;
  showLabelTitle?: boolean;
  videoProgress: number;
  videosWatched: number;
}

const VideoProgress = ({
  analyticsDisabledForAdmin,
  discrepancyInCompletion,
  numberOfVideos,
  showLabelTitle,
  videoProgress,
  videosWatched
}: Props) => {
  const { messages, theme, serverConfig } = useReduxState();

  if (numberOfVideos === 0 || videoProgress === null) {
    return (
      <div
        style={{
          color: theme.textColorLighter,
          fontSize: '1.3rem',
          whiteSpace: 'nowrap'
        }}
      >
        {messages.tasksNoVideos}
      </div>
    );
  }

  return (
    <div className="progress">
      <ProgressBar
        ariaLabel={messages.tasksVideos}
        color="rgba(0, 0, 0, 0.4)"
        label={
          <ProgressLabel
            analyticsDisabledForAdmin={analyticsDisabledForAdmin}
            discrepancyInCompletion={discrepancyInCompletion}
            title={showLabelTitle ? messages.tasksVideos : undefined}
            value={
              serverConfig.videoRequirementsType === 'individual'
                ? `${videosWatched || 0}/${numberOfVideos || 0}`
                : `${Math.round(videoProgress * 100)}%`
            }
          />
        }
        progress={
          serverConfig.videoRequirementsType === 'individual'
            ? videosWatched > 0
              ? videosWatched / numberOfVideos
              : 0
            : videoProgress
        }
        style={{ width: showLabelTitle ? '100%' : 64 }}
      />
    </div>
  );
};

export default VideoProgress;
